// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from 'D:/workspace/shilao-lease-super/src/pages/admManage/admDic/model';
import model_2 from 'D:/workspace/shilao-lease-super/src/pages/admManage/admLog/model';
import model_3 from 'D:/workspace/shilao-lease-super/src/pages/admManage/admRole/model';
import model_4 from 'D:/workspace/shilao-lease-super/src/pages/admManage/admUser/model';
import model_5 from 'D:/workspace/shilao-lease-super/src/pages/financial/userButieLog/model';
import model_6 from 'D:/workspace/shilao-lease-super/src/pages/financial/userPay/model';
import model_7 from 'D:/workspace/shilao-lease-super/src/pages/financial/userRefund/model';
import model_8 from 'D:/workspace/shilao-lease-super/src/pages/goodManage/goodCategory/model';
import model_9 from 'D:/workspace/shilao-lease-super/src/pages/goodManage/goodsList/model';
import model_10 from 'D:/workspace/shilao-lease-super/src/pages/orderManage/orderList/model';
import model_11 from 'D:/workspace/shilao-lease-super/src/pages/shopManage/shopList/model';
import model_12 from 'D:/workspace/shilao-lease-super/src/pages/shopManage/shopLog/model';
import model_13 from 'D:/workspace/shilao-lease-super/src/pages/shopManage/shopOperator/model';
import model_14 from 'D:/workspace/shilao-lease-super/src/pages/userManage/address/model';
import model_15 from 'D:/workspace/shilao-lease-super/src/pages/userManage/applyManage/model';
import model_16 from 'D:/workspace/shilao-lease-super/src/pages/userManage/user/model';

export const models = {
model_1: { namespace: 'admManage.admDic.model', model: model_1 },
model_2: { namespace: 'admManage.admLog.model', model: model_2 },
model_3: { namespace: 'admManage.admRole.model', model: model_3 },
model_4: { namespace: 'admManage.admUser.model', model: model_4 },
model_5: { namespace: 'financial.userButieLog.model', model: model_5 },
model_6: { namespace: 'financial.userPay.model', model: model_6 },
model_7: { namespace: 'financial.userRefund.model', model: model_7 },
model_8: { namespace: 'goodManage.goodCategory.model', model: model_8 },
model_9: { namespace: 'goodManage.goodsList.model', model: model_9 },
model_10: { namespace: 'orderManage.orderList.model', model: model_10 },
model_11: { namespace: 'shopManage.shopList.model', model: model_11 },
model_12: { namespace: 'shopManage.shopLog.model', model: model_12 },
model_13: { namespace: 'shopManage.shopOperator.model', model: model_13 },
model_14: { namespace: 'userManage.address.model', model: model_14 },
model_15: { namespace: 'userManage.applyManage.model', model: model_15 },
model_16: { namespace: 'userManage.user.model', model: model_16 },
} as const
